<form [formGroup]="group.controls[field.name]" [ngStyle]="field.containerStyles">
  <div class="group-title" *ngIf="field.label" [ngStyle]="field.labelStyles" [innerHTML]="field.label | gioNoSanitize">
  </div>

  <div class="form-group-container" [ngStyle]="field.fieldsContainerStyles">
    <ng-container *ngFor="let item of field.group;">
      <ng-container *ngIf="item.visible" [service]="service" [field]="item" [group]="group.controls[field.name]"
        gioFormField>
      </ng-container>

    </ng-container>
  </div>
</form>
